module.exports = __webpack_public_path__ + "1_0_65/img/200 The Shard.891b7521.jpg";